import React from 'react';
import './About.css'

const About = () => {
    return (
        <div className='about-shop'>
            <h1>This is Computer Shop, Here Branded & 2nd Hand Laptop, Laptop Bag, Mobile phone accessories, etc are available, they are the retailer.</h1>
        </div>
    );
};

export default About;